// extracted by mini-css-extract-plugin
export var coloredHeader = "Header-module--colored-header--oWkTY";
export var imageWidth = "Header-module--image-width--Ueokq";